import { ViewType } from "../components/ViewSelect.vue";
import { userIsCopywriterOnly } from "@/features/auth/utils/user-role-checks";

export const VIEW_TYPE_ALL: ViewType = "all";
export const VIEW_TYPE_COMMERCIAL: ViewType = "commercial";

export function viewIsTypeAll(view: string) {
  return view === VIEW_TYPE_ALL;
}

export function viewIsTypeCommercial(view: string) {
  return view === VIEW_TYPE_COMMERCIAL;
}

export function userShouldDefaultToCommercialView() {
  // We default to the commercial view if they ONLY have the nova_copywriter role
  return userIsCopywriterOnly();
}

export function areNonCommercialFieldsEditableForUser() {
  return !userIsCopywriterOnly();
}
